( function( $ ) {

    $(document).ready(function() {
        AOS.init({disable: 'mobile'});
    })

    /*input phone*/
    $('input[type="text"].js-phnInp').on('input', function() {
        this.value = this.value.replace(/[^0-9\+]/g, '');
    });
    /*input phone*/
 
    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*header*/
    $(window).scroll(function(){
        var hHeight = $('.js-header').outerHeight();
        if ($(window).scrollTop() > hHeight) {
            $('.js-header').removeClass('transp');
        } else {
            $('.js-header').addClass('transp');
        }
    });
    /*header*/

    /*header menu*/
    $('.js-hMenuBtn').click(function(){
        $(this).toggleClass('active');
        $('.js-hMenu').slideToggle();
    });


    $('.js-hMenu').click(function(e) {
        e.stopPropagation();
    });
    $('.js-hMenu ul li a').click(function(e) {
        if ($(window).width() < 992) {
            $('.js-hMenuBtn').removeClass('active');
            $('.js-hMenu').slideUp();
        }
    });

    $('.js-hMenuArr').click(function(e) {
        $(this).toggleClass('clicked');
        $(this).siblings('.sub-menu').slideToggle()
    });
    /*header menu*/

    /*modal contact*/
    $('.js-modlBtn, a[href="#modal"]').click(function(e){
        e.preventDefault();
        $('.js-modalWindow').addClass('active');
        $('body').css('overflow', 'hidden');
    })
    $('.js-modalWindowCls').click(function(){
        $('.js-modalWindow').removeClass('active');
        $('body').css('overflow', '');
    });
    /*modal contact*/

    /*video*/
    $(document).ready(function () {
        const player = $('#vimeo-player')[0];
        $('.js-firstLoud').on('click', function () {
            const $this = $(this);
            player.muted = !player.muted;
            $this.find('.sound').removeClass('active');
            if (player.muted) {
                $this.find('.sound[data-sound="disabled"]').addClass('active');
            } else {
                $this.find('.sound[data-sound="enabled"]').addClass('active');
            }
        });
    });
    /*video*/

    /*slider*/
    $('.js-sliderSlider').on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
        var cnt = slick.options.slidesToScroll;
        var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
        $(this).closest('.js-sliderSliderWrap').find('.js-sliderSliderCounter').html(
            '<span>' + slideNum + '</span><span class="sep"> — </span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
        );
    });

    $('.js-slider').slick({
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: '<button class="arrow prev-arrow"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.5 7.03535H15V8.03535H14.5V7.53535V7.03535ZM0.5 8.03535C0.223858 8.03535 0 7.8115 0 7.53535C0 7.25921 0.223858 7.03535 0.5 7.03535V7.53535V8.03535ZM7.03474 0.5V0L8.03474 0V0.5L7.53474 0.5L7.03474 0.5ZM0.810138 7.90359C0.567717 8.03583 0.263996 7.9465 0.131761 7.70408C-0.000475883 7.46166 0.0888472 7.15794 0.331269 7.0257L0.570704 7.46465L0.810138 7.90359ZM8.0348 14.5V15H7.0348V14.5H7.5348H8.0348ZM14.5 7.53535V8.03535L0.570761 8.03535V7.53535V7.03535L14.5 7.03535V7.53535ZM0.570761 7.53535V8.03535H0.5V7.53535V7.03535H0.570761V7.53535ZM7.53474 0.5L8.03474 0.5C8.03474 1.46517 7.51122 2.40874 6.83424 3.23966C6.14729 4.08282 5.24358 4.88117 4.35846 5.56517C3.4704 6.25145 2.58482 6.83499 1.92269 7.24634C1.59115 7.45231 1.31451 7.6158 1.12013 7.72814C1.02292 7.78432 0.946214 7.82775 0.893425 7.85735C0.867028 7.87215 0.846606 7.88349 0.832584 7.89124C0.825573 7.89512 0.820162 7.89809 0.816403 7.90016C0.814524 7.90119 0.813058 7.90199 0.812011 7.90257C0.811488 7.90285 0.811069 7.90308 0.810758 7.90325C0.810601 7.90334 0.810446 7.90342 0.810368 7.90346C0.81024 7.90353 0.810138 7.90359 0.570704 7.46465C0.331269 7.0257 0.331221 7.02573 0.331199 7.02574C0.331226 7.02573 0.33123 7.02572 0.331285 7.02569C0.331397 7.02563 0.331613 7.02552 0.331933 7.02534C0.332573 7.02499 0.333631 7.02441 0.335099 7.0236C0.338035 7.02199 0.342612 7.01947 0.348778 7.01607C0.361109 7.00925 0.379791 6.99887 0.404401 6.98508C0.453625 6.95748 0.526535 6.91621 0.619744 6.86234C0.806212 6.75457 1.07364 6.59655 1.39498 6.39691C2.03861 5.99706 2.89404 5.43305 3.74698 4.77391C4.60288 4.11249 5.44017 3.36754 6.05898 2.60803C6.68775 1.83627 7.03474 1.11779 7.03474 0.5L7.53474 0.5ZM0.570761 7.53535C0.758092 7.07177 0.758235 7.07183 0.758404 7.0719C0.758495 7.07194 0.758692 7.07202 0.758875 7.07209C0.759243 7.07224 0.759716 7.07243 0.760294 7.07267C0.761451 7.07314 0.763028 7.07378 0.765019 7.07459C0.769002 7.07622 0.77464 7.07854 0.781881 7.08153C0.796362 7.08752 0.817256 7.09624 0.844136 7.10764C0.89789 7.13042 0.975623 7.16395 1.07391 7.20785C1.27042 7.29563 1.54951 7.42506 1.88372 7.59332C2.55089 7.92919 3.44389 8.42281 4.34008 9.05202C5.23369 9.67942 6.14794 10.4537 6.84276 11.3556C7.53813 12.2583 8.0348 13.3172 8.0348 14.5H7.5348H7.0348C7.0348 13.6076 6.66095 12.7582 6.05057 11.9659C5.43963 11.1729 4.61287 10.4654 3.76547 9.87045C2.92066 9.27731 2.07265 8.808 1.43406 8.48652C1.1154 8.32609 0.850417 8.20325 0.66608 8.12091C0.573947 8.07976 0.502062 8.04877 0.453804 8.02831C0.429679 8.01808 0.411468 8.01049 0.399595 8.00558C0.39366 8.00312 0.389309 8.00134 0.386597 8.00023C0.385241 7.99967 0.384295 7.99929 0.383764 7.99907C0.383499 7.99896 0.383338 7.9989 0.383282 7.99888C0.383254 7.99886 0.383291 7.99888 0.383277 7.99887C0.38334 7.9989 0.38343 7.99894 0.570761 7.53535Z" fill="white"/> </svg></button>',
        nextArrow: '<button class="arrow next-arrow"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 7.03535H0L0 8.03535H0.5L0.5 7.53535L0.5 7.03535ZM14.5 8.03535C14.7761 8.03535 15 7.8115 15 7.53535C15 7.25921 14.7761 7.03535 14.5 7.03535V7.53535V8.03535ZM7.96526 0.5V0L6.96526 0V0.5L7.46526 0.5L7.96526 0.5ZM14.1899 7.90359C14.4323 8.03583 14.736 7.9465 14.8682 7.70408C15.0005 7.46166 14.9112 7.15794 14.6687 7.0257L14.4293 7.46465L14.1899 7.90359ZM6.9652 14.5V15H7.9652V14.5H7.4652H6.9652ZM0.5 7.53535L0.5 8.03535L14.4292 8.03535V7.53535V7.03535L0.5 7.03535L0.5 7.53535ZM14.4292 7.53535V8.03535H14.5V7.53535V7.03535H14.4292V7.53535ZM7.46526 0.5L6.96526 0.5C6.96526 1.46517 7.48878 2.40874 8.16576 3.23966C8.85271 4.08282 9.75642 4.88117 10.6415 5.56517C11.5296 6.25145 12.4152 6.83499 13.0773 7.24634C13.4088 7.45231 13.6855 7.6158 13.8799 7.72814C13.9771 7.78432 14.0538 7.82775 14.1066 7.85735C14.133 7.87215 14.1534 7.88349 14.1674 7.89124C14.1744 7.89512 14.1798 7.89809 14.1836 7.90016C14.1855 7.90119 14.1869 7.90199 14.188 7.90257C14.1885 7.90285 14.1889 7.90308 14.1892 7.90325C14.1894 7.90334 14.1896 7.90342 14.1896 7.90346C14.1898 7.90353 14.1899 7.90359 14.4293 7.46465C14.6687 7.0257 14.6688 7.02573 14.6688 7.02574C14.6688 7.02573 14.6688 7.02572 14.6687 7.02569C14.6686 7.02563 14.6684 7.02552 14.6681 7.02534C14.6674 7.02499 14.6664 7.02441 14.6649 7.0236C14.662 7.02199 14.6574 7.01947 14.6512 7.01607C14.6389 7.00925 14.6202 6.99887 14.5956 6.98508C14.5464 6.95748 14.4735 6.91621 14.3803 6.86234C14.1938 6.75457 13.9264 6.59655 13.605 6.39691C12.9614 5.99706 12.106 5.43305 11.253 4.77391C10.3971 4.11249 9.55983 3.36754 8.94102 2.60803C8.31225 1.83627 7.96526 1.11779 7.96526 0.5L7.46526 0.5ZM14.4292 7.53535C14.2419 7.07177 14.2418 7.07183 14.2416 7.0719C14.2415 7.07194 14.2413 7.07202 14.2411 7.07209C14.2408 7.07224 14.2403 7.07243 14.2397 7.07267C14.2385 7.07314 14.237 7.07378 14.235 7.07459C14.231 7.07622 14.2254 7.07854 14.2181 7.08153C14.2036 7.08752 14.1827 7.09624 14.1559 7.10764C14.1021 7.13042 14.0244 7.16395 13.9261 7.20785C13.7296 7.29563 13.4505 7.42506 13.1163 7.59332C12.4491 7.92919 11.5561 8.42281 10.6599 9.05202C9.76631 9.67942 8.85206 10.4537 8.15724 11.3556C7.46187 12.2583 6.9652 13.3172 6.9652 14.5H7.4652H7.9652C7.9652 13.6076 8.33905 12.7582 8.94943 11.9659C9.56037 11.1729 10.3871 10.4654 11.2345 9.87045C12.0793 9.27731 12.9274 8.808 13.5659 8.48652C13.8846 8.32609 14.1496 8.20325 14.3339 8.12091C14.4261 8.07976 14.4979 8.04877 14.5462 8.02831C14.5703 8.01808 14.5885 8.01049 14.6004 8.00558C14.6063 8.00312 14.6107 8.00134 14.6134 8.00023C14.6148 7.99967 14.6157 7.99929 14.6162 7.99907C14.6165 7.99896 14.6167 7.9989 14.6167 7.99888C14.6167 7.99886 14.6167 7.99888 14.6167 7.99887C14.6167 7.9989 14.6166 7.99894 14.4292 7.53535Z" fill="white"/> </svg></button>',
        appendArrows: $('.js-sliderSliderWrap').find('.js-sliderSliderArrows')
    });
    /*slider*/

    /*wpcf7 thankyou*/
    document.addEventListener('wpcf7mailsent', function (event) {
        $('.js-modalContact').addClass('active');
        $('body').css('overflow', 'hidden');
    }, false);
    $('.js-modalContactCls').click(function(){
        $('.js-modalContact').removeClass('active');
        $('body').css('overflow', '');
    });
    /*wpcf7 thankyou*/

    /*scroll sidebar*/
    /*$(window).on('load resize', function(){
        if ($('.js-pageTextSide').length > 0) {
            if ($(window).width() > 991) {
                var singleSidebarTop = $('.js-pageTextSide').offset().top;
                var singleSidebarRailTop = $('.js-pageTextSideRail').offset().top;
                var headerOffset = $('header').outerHeight();
                var windowTop = $(window).scrollTop() + headerOffset + 30;

                var singleSidebarH = $('.js-pageTextSide').outerHeight();
                var singleSidebarMenuH = $('.js-pageTextSideMenu').outerHeight();
                if (singleSidebarH > singleSidebarMenuH) {
                    $('.js-pageTextSideRail').height(singleSidebarH - singleSidebarMenuH);
                }
                var singleSidebarRailH = $('.js-pageTextSideRail').outerHeight();
                var singleSidebarRailBottom = singleSidebarRailTop + singleSidebarRailH;

                $(window).scroll(function(){
                    windowTop = $(window).scrollTop() + headerOffset + 30;
                    if (windowTop > singleSidebarTop && windowTop < singleSidebarRailBottom) {
                        $('.js-pageTextSideMenu').css('top', windowTop - singleSidebarTop)
                    } else if (windowTop > singleSidebarTop && windowTop >= singleSidebarRailBottom) {
                        $('.js-pageTextSideMenu').css('top', '100%')
                    } else if (windowTop <= singleSidebarTop) {
                        $('.js-pageTextSideMenu').css('top', '0')
                    }
                })
            } else {
                $('.js-pageTextSideRail').css('height', 'auto')
            }
        }
    })*/
    /*scroll sidebar*/

    /*page faq*/
    /*$('.js-pageFaqCat').click(function(){
        var id = $(this).data('id');
        if (id === 'all') {
            $('.js-pageFaqListItem').slideDown();
        } else if ($('.js-pageFaqCat.active').data('id') === 'all') {
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').slideUp();
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').removeClass('opened');
        } else {
            $('.js-pageFaqListItem').slideUp();
            $('.js-pageFaqListItem').removeClass('opened');
            $('.js-pageFaqListItem[data-id="'+id+'"]').slideDown();
            $('.js-pageFaqListItem[data-id="'+id+'"]').addClass('opened');
        }
        $('.js-pageFaqCat').removeClass('active')
        $(this).addClass('active')


        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $('.js-pageFaqListItem.opened .js-pageFaqListBurg').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgWrap').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgTxt').eq(0).slideDown()
    })
    $('.js-pageFaqListBurg').click(function(){
        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $(this).addClass('active')
        $(this).closest('.js-pageFaqListBurgWrap').addClass('active')
        $(this).siblings('.js-pageFaqListBurgTxt').slideDown()
    })*/
    /*page faq*/

    /*main-team*/
    $(window).on('load resize', function () {

        if ($(window).width() > 991) {

            if ($('.js-mainTeamSliderMob').hasClass('slick-initialized')) {
                setTimeout(function(){$('.js-mainTeamSliderMob').slick('unslick');}, 200)
            }

        } else {
            if (!$('.js-mainTeamSliderMob').hasClass('slick-initialized')) {
                $('.js-mainTeamSliderMob').on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
                    var cnt = slick.options.slidesToScroll;
                    var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
                    $('.js-mainTeamSliderMobCounter').html(
                        '<span>' + slideNum + '</span><span class="sep"> / </span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
                    );
                    if (slideNum == (Math.ceil(slick.slideCount / cnt))) {
                        $('.js-mainTeamSliderMobCounter').parent().css('display', 'none')
                    } else {
                        $('.js-mainTeamSliderMobCounter').parent().css('display', '')
                    }
                });
                $('.js-mainTeamSliderMob').slick({
                    arrows: true,
                    dots: false,
                    centerMode: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    prevArrow: '<button type="button" class="slick-arrow prev"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
                    nextArrow: '<button type="button" class="slick-arrow next"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
                    appendArrows: $('.js-mainTeamSliderMobArrows'),
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }
                    ]
                });
            }
        }
    });
    /*main-team*/


    /*main-traits*/
    $('.js-mainTraitsVid iframe').each(function() {
        var iframe = this;
        var player = new Vimeo.Player(iframe);

        player.setCurrentTime(0);
        player.pause();

        var $wrap = $(iframe).parent();

        $wrap.on('mouseenter', function() {
            player.play().catch(function() {

            });
        });

        $wrap.on('mouseleave', function() {
            player.pause();
        });
    });
    /*main-traits*/

    /*main-gallery*/
    $('.js-mainGallerySlider').on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
        var cnt = slick.options.slidesToScroll;
        var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
        $(this).closest('.js-mainGalleryWrap').find('.js-mainGalleryCounter').html(
            '<span>' + slideNum + '</span><span class="sep"> / </span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
        );
    });
    $('.js-mainGallerySlider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        centerMode: true,
        centerPadding: '20.8vw',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        speed: 600,
        prevArrow: '<button type="button" class="slick-arrow prev"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-arrow next"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        appendArrows: $('.js-mainGalleryArrows'),
        responsive: [
            { breakpoint: 1200, settings: { autoplay: false } },
            { breakpoint: 768,  settings: { centerPadding: '60px' } },
            { breakpoint: 576,  settings: { centerPadding: '20px' } }
        ]
    });
    /*main-gallery*/

    /*page blog slider*/
    function pageBlogCounter($slider, slick, nextSlide) {
        var show   = slick.options.slidesToShow  || 1;
        var scroll = slick.options.slidesToScroll || 1;
        var count  = slick.slideCount;

        var all = Math.max(1, Math.ceil(count / scroll));

        var index = (nextSlide === undefined || nextSlide === null) ? slick.currentSlide : nextSlide;
        var cur;

        if (index <= 0) {
            cur = 1;
        } else if (index + show >= count) {
            cur = all;
        } else {
            cur = Math.floor(index / scroll) + 1;
        }
        cur = Math.min(Math.max(cur, 1), all);

        $slider.closest('.page-blog').find('.js-pageBlogCounter').html(
            '<span class="cur">' + cur + '</span><span class="sep"> / </span><span class="all">' + all + '</span>'
        );
    }

    $('.js-pageBlogSlider').on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
        pageBlogCounter($(this), slick, nextSlide);
    });

    $('.js-pageBlogSlider').on('breakpoint', function(event, slick){
        pageBlogCounter($(this), slick);
    });

    $('.js-pageBlogSlider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        adaptiveHeight: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        speed: 500,
        prevArrow: '<button type="button" class="slick-arrow prev"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-arrow next"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        appendArrows: $('.js-pageBlogArrows'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    /*page blog slider*/

    /*page-cons*/
    $('.js-pageConsSlider').on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
        var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
        $(this).closest('.page-cons').find('.js-pageConsCounter').html(
            '<span class="cur">' + slideNum + '</span><span class="sep"> / </span><span class="all">' + slick.slideCount + '</span>'
        );
    });
    $('.js-pageConsSlider').slick({
        arrows: true,
        dots: false,
        infinite: false,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        prevArrow: '<button type="button" class="slick-arrow prev"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-arrow next"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        appendArrows: $('.js-pageConsArrows')
    });
    $('.js-pageConsMobSlider').on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
        var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
        $(this).closest('.page-cons').find('.js-pageConsMobCounter').html(
            '<span class="cur">' + slideNum + '</span><span class="sep"> / </span><span class="all">' + slick.slideCount + '</span>'
        );
    });
    $('.js-pageConsMobSlider').slick({
        arrows: true,
        dots: false,
        infinite: false,
        adaptiveHeight: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        prevArrow: '<button type="button" class="slick-arrow prev"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-arrow next"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        appendArrows: $('.js-pageConsMobArrows')
    });
    /*page-cons*/

    /*page faq*/
    $('.js-pageFaqCat').click(function(){
        var id = $(this).data('id');
        if (id === 'all') {
            $('.js-pageFaqListItem').slideDown();
        } else if ($('.js-pageFaqCat.active').data('id') === 'all') {
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').slideUp();
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').removeClass('opened');
        } else {
            $('.js-pageFaqListItem').slideUp();
            $('.js-pageFaqListItem').removeClass('opened');
            $('.js-pageFaqListItem[data-id="'+id+'"]').slideDown();
            $('.js-pageFaqListItem[data-id="'+id+'"]').addClass('opened');
        }
        $('.js-pageFaqCat').removeClass('active')
        $(this).addClass('active')

        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $('.js-pageFaqListItem.opened .js-pageFaqListBurg').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgWrap').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgTxt').eq(0).slideDown()
    })
    $('.js-pageFaqListBurg').click(function(){
        var hideOnly = $(this).closest('.js-pageFaqListBurgWrap').hasClass('active');
        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        if (!hideOnly) {
            $(this).addClass('active')
            $(this).closest('.js-pageFaqListBurgWrap').addClass('active')
            $(this).siblings('.js-pageFaqListBurgTxt').slideDown()
        }
    })
    /*page faq*/

    /*page cabinet technologies*/
    let simpleBarInstance = null;
    $('.js-modalCabinTechBtn').click(function(){
        $('.js-modalCabinTechWrap').html($(this).find('.js-modalCabinTechWrapInner').html());
        $('.js-modalCabinTech').addClass('active');
        if ($(this).hasClass('js-pageVidsBl')) {
            let videoId = $(this).data('video');
            let iframeSrc = '';
            iframeSrc = 'https://player.vimeo.com/video/' + videoId +
                '?autoplay=1&loop=1&background=1&autopause=0&muted=1';
            var iframe = $('<iframe>', {
                src: iframeSrc,
                width: 493,
                height: 493,
                frameborder: 0,
                allow: 'autoplay; fullscreen',
                allowfullscreen: true
            });
            $('.js-modalCabinTechWrap .js-modalCabinTechWrapVid').append(iframe);
        }
        if ($(window).width() > 991) {
            const rightEl = document.querySelector('.js-modalCabinTechWrap .js-modalCabinTechWrapRight');
            if (rightEl) {
                simpleBarInstance = new SimpleBar(rightEl);
            }
        }
        $('body').css('overflow', 'hidden');
    })
    $('.js-modalCabinTechCls').click(function(){
        $('.js-modalCabinTechWrap').html('');
        $('.js-modalCabinTech').removeClass('active');
        if (simpleBarInstance) {
            simpleBarInstance.unMount();
            simpleBarInstance = null;
        }
        $('body').css('overflow', '');
    });
    /*page cabinet technologies*/

    /*widgets*/
    $(window).load(function(){
        $('.js-widgToolsBlLang').attr('data-lang', $('.js-widgToolsBlGLang .glink.gt-current-lang').data('gt-lang'));
    })
    $('body').on('click', '.js-widgToolsBlGLang .glink', function(){
        $('.js-widgToolsBlLang').attr('data-lang', $(this).data('gt-lang'));
    })
    /*widgets*/

    /*rellax*/
    if ($('.js-parallax').length > 0) {
        const rellax = new Rellax('.js-parallax', {
            speed: -2,
            center: true
        });
    }
    /*rellax*/

    /*breadcrumbs*/
    $(document).ready(function() {
        if ($(window).width() > 991) {
            const rightEl = document.querySelector('.js-breadcrumbsWrap');
            if (rightEl) {
                simpleBarInstance = new SimpleBar(rightEl);
            }
        }
    })
    /*breadcrumbs*/

}( jQuery ) );
